var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("仓库管理")]),
            ]),
            _c(
              "el-breadcrumb-item",
              { attrs: { to: { path: "/warehouseStock" } } },
              [_c("div", { staticClass: "div3" }, [_vm._v("仓库列表")])]
            ),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("商品记录详情")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "table" },
      [
        _c("p", { staticClass: "header" }, [_vm._v("记录")]),
        _c(
          "el-form",
          {
            ref: "form",
            attrs: { inline: true, model: _vm.record, size: "mini" },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "相关信息" } },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: "请输入采购单号/采购人",
                    value: "ejri",
                  },
                  model: {
                    value: _vm.record.info,
                    callback: function ($$v) {
                      _vm.$set(_vm.record, "info", $$v)
                    },
                    expression: "record.info",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { staticClass: "formItem", attrs: { label: "仓库名称" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: { clearable: "", placeholder: "请选择仓库名称" },
                    model: {
                      value: _vm.record.wareName,
                      callback: function ($$v) {
                        _vm.$set(_vm.record, "wareName", $$v)
                      },
                      expression: "record.wareName",
                    },
                  },
                  _vm._l(_vm.wareData, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.name, value: item.id },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "selectDate" }, [
              _c("span", [_vm._v("时间")]),
              _c(
                "div",
                { staticClass: "picker" },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "unlink-panels": "",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      format: "yyyy-MM-dd",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.record.date,
                      callback: function ($$v) {
                        _vm.$set(_vm.record, "date", $$v)
                      },
                      expression: "record.date",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.searchEvent()
                      },
                    },
                  },
                  [_vm._v("搜索")]
                ),
                _c(
                  "el-button",
                  { attrs: { size: "mini" }, on: { click: _vm.resetEvent } },
                  [_vm._v("重置")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "tableContext" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.tableData.list },
            on: { "selection-change": _vm.handleSelectionChange },
          },
          [
            _c("el-table-column", {
              attrs: { type: "selection", width: "50" },
            }),
            _c("el-table-column", {
              attrs: { label: "序号", type: "index", width: "80" },
            }),
            _c("el-table-column", {
              attrs: { prop: "oddNumber", label: "采购单号" },
            }),
            _c("el-table-column", {
              attrs: { prop: "handlerBy", label: "采购人" },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "createdTime",
                label: "采购时间",
                "min-width": "120",
              },
            }),
            _c("el-table-column", {
              attrs: { prop: "total", label: "采购总数" },
            }),
            _vm._l(_vm.wareData, function (item) {
              return _c("el-table-column", {
                key: item.id,
                attrs: {
                  prop: "total",
                  label: item.name + "(数量)",
                  width: "100",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          props.row.warehouses
                            ? _c(
                                "div",
                                _vm._l(props.row.warehouses, function (val) {
                                  return _c("p", { key: val.warId }, [
                                    item.id == val.warId
                                      ? _c("span", [_vm._v(_vm._s(val.number))])
                                      : _vm._e(),
                                  ])
                                }),
                                0
                              )
                            : _c("span", [_vm._v("--")]),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
          ],
          2
        ),
      ],
      1
    ),
    _vm.tableData.totalNum > 0
      ? _c("div", { staticClass: "page" }, [
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pageNo,
                  "page-sizes": [10, 20, 50, 100, 200],
                  "page-size": _vm.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.totalNum,
                  "prev-text": "上一页",
                  "next-text": "下一页",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }